/**
 * Partner-facing legal agreements rendered as the agreement-checkbox
 * link on /signuptype and /onboarding. Hosted on
 * partners.agoda.com/Content/pdf, so they're not CMS-driven.
 *
 * Single source of truth — touch these here and both signup pages
 * pick up the change.
 */

export const AFFILIATE_AGREEMENT_PDF =
    'https://partners.agoda.com/Content/pdf/Agoda_OnlineAffiliateAgreement.pdf';

export const AMBASSADOR_AGREEMENT_PDF =
    'https://partners.agoda.com/Content/pdf/Agoda_OnlineAgodaAmbassadorAgreement.pdf';

export const CORPORATE_AGREEMENT_PDF =
    'https://partners.agoda.com/Content/pdf/Agoda_Business_Travel_Program_Agreement.pdf';
